import React from 'react';

import { TextField, FormControlLabel, Checkbox } from '@material-ui/core';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox'; 

import styles from '../../readyForCarriageCheck/readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';

interface GeneralRemarksProps {
  generalRemarks: string;
  disabled: boolean;
  handleChange: (event: any, type: string) => void;
  handleSetRemarks: () => void;
  customerError: boolean;
  remarksError: boolean;
};

const TEXT_FIELD_PADDINGS: string = '10px 6px 10px 10px';
const TEXT_FIELD_WIDTH: string = '100%';
const SELECT_FONT_SIZE: string = '13px';

const generalRemarks = (props: GeneralRemarksProps) => {

  return (
    <div className={ `${commonStyles.wrapper}` }>
      <div className={ commonStyles.fSpaceBtw }>
        <h3 className={ `${commonStyles.header}` }>
          General Remarks
        </h3>
        <FormControlLabel
          value="cust_error"
          control={
            <Checkbox
              name=''
              checked={ props.customerError || false }
              onChange={ (e) => props.handleChange(e, 'ce') }
              icon={<CheckBoxOutlineBlankIcon  color="primary" />}
              checkedIcon={ <Checkbox  onChange={ (e) => props.handleChange(e, 'ce') } checked={ props.customerError }  color="primary" className={ commonStyles.p0 }/> }
            />
          }
          label={'Mark as customer error (Remarks Mandatory)'}
          className={ commonStyles.mr0 }
        />  
      </div>
      
      <div className={ styles.notesWrapper }>
        <TextField
          multiline
          value={ props.generalRemarks }
          error={ props.remarksError } 
          helperText={ props.remarksError ? 'Add Remarks' : '' }
          variant="outlined"
          onChange={ (e) => props.handleChange(e, 'remarks') }
          onBlur={ props.handleSetRemarks }
          disabled={ props.disabled }
          InputProps={ { style: { padding: TEXT_FIELD_PADDINGS, width: TEXT_FIELD_WIDTH, fontSize: SELECT_FONT_SIZE } } }
          fullWidth
        />
      </div>
    </div>
  );
}

export default generalRemarks;